const STAMP = String.raw`\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2}`;
const RANGE_NAME = new RegExp(`^(${STAMP})_(${STAMP})`);

const stamp = (wallMs: number): string => new Date(wallMs).toISOString().slice(0, 19).replaceAll(':', '-');

export const rangeFileName = (startWallMs: number, endWallMs: number): string => `${stamp(startWallMs)}_${stamp(endWallMs)}.mp4`;

export function mergedFileName(names: readonly string[], nowWallMs: number): string {
  const ranges = names.flatMap((name) => {
    const match = RANGE_NAME.exec(name);
    return match ? [{ start: match[1]!, end: match[2]! }] : [];
  });
  if (ranges.length === 0 || ranges.length !== names.length) return `tesla-merged-${stamp(nowWallMs)}.mp4`;
  const start = ranges.map((range) => range.start).sort()[0];
  const end = ranges.map((range) => range.end).sort().at(-1);
  return `${start}_${end}.mp4`;
}
